<template>
    <div class="privacy-statement-container">
        <!-- <header class="" @click="back">
            <i class=" rotate iconfont icon-zuojiantou"></i>
            隐私服务
        </header> -->
        <div
            v-for="(item, index) in statement"
            :key="index">
            <h2
                v-if="item.strong"
                class="font14"
                :class="{ 'ident2': item.ident === 2, 'ident4': item.ident === 4, 'font16': item.font === 2 }">
                {{ item.info }}
            </h2>
            <div
                v-else
                class="margin-bottom"
                :class="{ 'strong': item.strong, 'ident2': item.ident === 2, 'ident4': item.ident === 4, 'font16': item.font === 2 } ">
                {{ item.info }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            statement: [
                {
                    strong: false,
                    ident: 2,
                    info: '本软件尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本软件会按照本隐私权政策的规定使用和披露您的个人信息。但本软件将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本软件不会将这些信息对外披露或向第三方提供。本软件会不时更新本隐私权政策。您在同意本软件服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本软件服务使用协议不可分割的一部分。',
                    font: false
                },
                {
                    strong: true,
                    ident: false,
                    info: '1.适用范围',
                    font: false
                },
                {
                    strong: false,
                    ident: 2,
                    info: 'a)在您使用本软件网络服务，本软件自动接收并记录的您的手机上的信息，包括但不限于您的健康数据、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；',
                    font: false
                },
                {
                    strong: true,
                    ident: false,
                    info: '2.信息的使用',
                    font: false
                },
                {
                    strong: false,
                    ident: 2,
                    info: 'a)在获得您的数据之后，本软件会将其上传至服务器，以生成您的排行榜数据，以便您能够更好地使用服务。',
                    font: false
                },
                {
                    strong: true,
                    ident: false,
                    info: '3.信息披露',
                    font: false
                },
                {
                    strong: false,
                    ident: 2,
                    info: 'a)本软件不会将您的信息披露给不受信任的第三方；',
                    font: false
                },
                {
                    strong: true,
                    ident: 2,
                    info: 'b)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；',
                    font: false
                },
                {
                    strong: true,
                    ident: 2,
                    info: 'c)如您出现违反中国有关法律、法规或者相关规则的情况，需要向第三方披露。',
                    font: false
                },

                {
                    strong: true,
                    ident: false,
                    info: '4.信息存储和交换',
                    font: false
                },
                {
                    strong: false,
                    ident: 2,
                    info: 'a)本软件收集的有关您的信息和资料将保存在本软件及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本软件收集信息和资料所在地的境外并在境外被访问、存储和展示。',
                    font: false
                },
                {
                    strong: true,
                    ident: false,
                    info: '5.信息安全',
                    font: false
                },
                {
                    strong: false,
                    ident: 2,
                    info: 'a)在使用本软件网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，请您立即联络本软件客服，以便本软件采取相应措施。',
                    font: false
                }
            ]
        };
    },
    methods: {
        back () {}
    }
};
</script>

<style lang="scss" scoped>
    .privacy-statement-container {
        padding: 15px;
        font-size: .8rem;
        text-align: justify;

        header {
            margin-bottom: 15px;
            font-weight: 600;
            text-align: center;
        }

        .iconfont {
            float: left;
        }

        .margin-bottom {
            margin-bottom: 5px;
        }

        .strong {
            font-weight: 600;
        }

        .ident2 {
            text-indent: 1.6rem;
        }

        .ident4 {
            text-indent: 2.4rem;
            font-size: .7rem;
            margin-bottom: 2px;
        }

        .font14 {
            font-size: .8rem;
        }

        .font16 {
            font-size: 1rem;
        }
    }
</style>

